<header class="home-header">
    <background-control></background-control>

    <div class="container">
        <div class="hero-intro text-center">
            <div class="hero-badge">
                <span></span>
                {{ 'home_page.wecdev' | translate }}
            </div>
            <h1 [translate]="'home_page.welcome_to'"></h1>
            <i18n-html-content-loader-control [filePostFix]="'header'"></i18n-html-content-loader-control>
        </div>

        <div class="hero-cards">
            <div class="hero-card">
                <div class="hero-card-icon">
                    <img src="@imagesDir/web-dev.png" alt="---business-icon.png---" title="" />
                </div>
                <div class="hero-card-content">
                    <h2 [translate]="'home_page.website_and_extension_development'"></h2>
                    <p>{{ 'home_page.website_and_extension_development_description' | translate }}</p>
                </div>
                <a (click)="utils.scrollToElement('development')" class="hero-button" [translate]="'common.details'"> </a>
            </div>

            <div class="hero-card hero-card-accent">
                <div class="hero-card-icon">
                    <img src="@imagesDir/free-stuff.png" alt="---free-zone.png---" title="" />
                </div>
                <div class="hero-card-content">
                    <h2 [translate]="'home_page.free_zone'"></h2>
                    <p>{{ 'home_page.free_zone_description' | translate }}</p>
                </div>
                <a (click)="utils.scrollToElement('extensions')" class="hero-button" [translate]="'common.details'"> </a>
            </div>
        </div>

        <div class="hero-scroll-indicator">
            <span></span>
            {{ 'home_page.scroll_to_explore' | translate }}
        </div>
    </div>
</header>

<section id="development" class="development-section">
    <div class="section-decoration section-decoration-purple"></div>
    <div class="container">
        <div class="section-heading text-center">
            <div class="section-icon">
                <img src="@imagesDir/web-dev.png" alt="---business-icon.png---" title="" />
            </div>
            <span class="section-label text-uppercase" [translate]="'home_page.what_we_do'"></span>
            <h2 [translate]="'home_page.website_and_extension_development'"></h2>
            <div class="section-divider"></div>
        </div>
        <div class="service-card">
            <div class="service-number">01</div>
            <div class="service-content">
                <i18n-html-content-loader-control [filePostFix]="'business_1'"> </i18n-html-content-loader-control>

                <a class="contact-us" (click)='openContactFormModal("extension")' [translate]="'common.contact_us'"> </a>
            </div>
        </div>
        <div class="service-card service-card-reverse">
            <div class="service-number">02</div>
            <div class="service-content">
                <i18n-html-content-loader-control [filePostFix]="'business_2'"> </i18n-html-content-loader-control>
                <a class="contact-us" (click)='openContactFormModal("development")' [translate]="'common.contact_us'"> </a>
            </div>
        </div>
        <div class="service-card service-card-reverse">
            <div class="service-number">03</div>
            <div class="service-content">
                <i18n-html-content-loader-control [filePostFix]="'business_3'"> </i18n-html-content-loader-control>
                <a class="contact-us" (click)='openContactFormModal("development")' [translate]="'common.contact_us'"> </a>
            </div>
        </div>
    </div>
</section>

<section id="extensions" class="extensions-section">
    <div class="section-decoration section-decoration-blue"></div>

    <div class="container">
        <div class="section-heading text-center">
            <div class="section-icon">
                <img src="@imagesDir/free-stuff.png" alt="---free-zone.png---" title="" />
            </div>
            <span class="section-label text-uppercase" [translate]="'home_page.free_zone'"></span>
            <h2 [translate]="'home_page.free_zone'"></h2>
            <div class="section-divider"></div>
        </div>

        <div class="extension-card">
            <div class="extension-card-header">
                <div class="extension-icon">
                    <img src="@imagesDir/spoiler-protection-icon128.png" alt="---spoiler-protection-icon.png---" title="" />
                </div>
                <div class="extension-title">
                    <span class="feature-label text-uppercase" [translate]="'home_page.browser_extension'"></span>
                    <h3 [translate]="'home_page.spoiler_protection_title'"></h3>
                    <p [translate]="'home_page.spoiler_protection_text'" class="text-muted"></p>
                </div>
            </div>
            <div class="extension-preview">
                <div class="preview-card">
                    <div class="preview-label">
                        <span></span>
                        <p [translate]="'home_page.before'"></p>
                    </div>
                    <img src="@imagesDir/spoiler-protection-before.png" alt="---spoiler-protection-before.png---" title="" />
                </div>
                <div class="preview-arrow"><i class="bi bi-arrow-right"></i></div>
                <div class="preview-card">
                    <div class="preview-label">
                        <span></span>
                        <p [translate]="'home_page.after'"></p>
                    </div>
                    <img src="@imagesDir/spoiler-protection-after.png" alt="---spoiler-protection-after.png---" title="" />
                </div>
            </div>
            <div class="extension-download">
                <div>
                    <span class="feature-label text-uppercase" [translate]="'home_page.get_started'"></span>
                    <h3 [translate]="'common.download'"></h3>
                </div>
                <download-extension-control [imageWidth]="'100%'" #downloadExtensionSpoilerProtection> </download-extension-control>
            </div>
        </div>
    </div>
</section>

<section id="social" class="social-section" hidden>
    <div class="container">
        <div class="social-card">
            <div class="social-decoration"></div>
            <subscribe-wecdev-control></subscribe-wecdev-control>
        </div>
    </div>
</section>

<contact-form-control></contact-form-control>
